import dayjs from 'dayjs';
export const AUTO_OPEN_OFF_MOMENT = dayjs('2026-04-21T00:00:00.000Z');
